var toCamelCase = function toCamelCase(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (ltr, idx) {
    return idx === 0 ? ltr.toLowerCase() : ltr.toUpperCase();
  }).replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, '');
};

export default toCamelCase;